import { IHexGridData } from 'js/bubbleCore/types';
import { colRowToHash } from 'js/bubbleCore/utils/hash';

export function setGridValue<T>(grid: IHexGridData<T>, col: number, row: number, value: T): T | null {
  return grid.values[colRowToHash(col, row)] = value;
}